import type { TOC } from '@ember/component/template-only';
import type { IconBrandName } from '@mylighthouse/prism-ember/types/components/prism/icon-brand';
import ParityOtaWithIcon from 'lumen/components/parity/ota-with-icon';

interface ParityTablesCellsTdOtaSignature {
  Args: { cellData: IconBrandName };
}

const ParityTablesCellsTdOta = <template>
  <ParityOtaWithIcon @otaId={{@cellData}} @size="small" />
</template> satisfies TOC<ParityTablesCellsTdOtaSignature>;

export default ParityTablesCellsTdOta;
